// extracted by mini-css-extract-plugin
module.exports = {"image":"_761af51","label":"_d9b00d4"};